import React from 'react';
import { RouteObject } from 'react-router-dom';
import { appRoutes } from '../../../path';
import ProtectedRoute from '../../../components/ProtectedRoute';
import { PermissionKey } from '../../../utils/apollo/graphqlSchema';
import Roles from './Roles';
import RoleOverview from './RoleOverview';
import RoleModify from './RoleModify';

const roleRoutes: RouteObject[] = [
  {
    path: appRoutes.permission.roles,
    element: <Roles />,
  },
  {
    path: appRoutes.permission.roles + '/:roleId',
    element: <RoleOverview />,
  },
  {
    path: appRoutes.permission.createRole,
    element: (
      <ProtectedRoute allRequiredPermissionKeys={[PermissionKey.AdminCreate]}>
        <RoleModify />
      </ProtectedRoute>
    ),
  },
  {
    path: appRoutes.permission.roles + '/:roleId/edit',
    element: (
      <ProtectedRoute allRequiredPermissionKeys={[PermissionKey.AdminEdit]}>
        <RoleModify />
      </ProtectedRoute>
    ),
  },
];

export default roleRoutes;
